import * as Types from '../types/authTypes'

const initalState = {
  isAuthenticated: false,
  msgText: '',
  email: null,
  errorStatus: 0,
  loginError: false,
  msgTitle: '',
  distributorName: '',
  distributorImage: '',
  msgCode: '',
  existingUser: false,
  verificationCodeGenerated: false,
  verificationAttempted: false,
  emailVerified: false,
  applicationsSubmitted: null,
  approvalRate: 0,
  displayFlag: 0,
  excessiveApplicationActivity: null,
  fourMonthLapseRate: 0,
  freeLookCancel: 0,
  policiesIssued: 0,
  qualityScore: null,
  statusCode: 0,
  underwritingInaccuracy: '',
  chartTotals: null,
  affiliateCode: '',
  userSourceCode: '',
  agentRank: null,
  monthlyData: {
    approvalRate: null,
    declineRate: null,
    conversionRate: null,
    policyIssuedRate: null,
    ticketsOpened: null,
    ticketsInProgress: null,
    ticketsClosed: null,
  },
  productAccess: null,
  productEligible: null,
  productLibrary: null,
  quarterlyData: {
    approvalRate: null,
    declineRate: null,
    conversionRate: null,
    policyIssuedRate: null,
    ticketsOpened: null,
    ticketsInProgress: null,
    ticketsClosed: null,
  },
  weeklyData: {
    approvalRate: null,
    declineRate: null,
    conversionRate: null,
    policyIssuedRate: null,
    ticketsOpened: null,
    ticketsInProgress: null,
    ticketsClosed: null,
  },
  yearlyData: {
    approvalRate: null,
    declineRate: null,
    conversionRate: null,
    policyIssuedRate: null,
    ticketsOpened: null,
    ticketsInProgress: null,
    ticketsClosed: null,
  },
  openCases: [
    {
      agent_expiration_date: null,
      approved_incomplete_apps_count: null,
      expiration_days: null,
      missing_first_payment_count: null,
      paid_not_signed_count: null,
      risk_of_lapse_days: null,
    },
  ],
  notificationMessage: [
    {
      alert_id: null,
      message: null,
      sequence: null,
    },
  ],
  productId: null,
  distributorId: null,
  relationalType: null,
  totalNumAgencies: null,
  totalNumAgents: null,
  agentList: null,
  otpStatus: null,
  otpValidateStatus: null,
  otpFlag: 0,
  productList: [],
  agencyList: [],
  distributorList: [],
  firstName: '',
  lastName: '',
}

export default function authReducer(state = initalState, action) {
  switch (action.type) {
    case Types.LOGIN_SUCCESS:
      return {
        ...state,
        isAuthenticated: true,
        loginError: false,
        email: action.payload.email,
        firstName: action.payload.firstName,
        affiliateCode: action.payload.affiliateCode,
        userSourceCode: action.payload.distributorId,
        otpFlag: action.payload.otpFlag,
      }
    case Types.LOGIN_REQUEST:
      return {
        ...state,
        loginError: false,
      }
    case Types.LOGIN_FAILURE:
      return {
        ...state,
        loginError: true,
        msgText: action.payload.msgText,
        msgTitle: action.payload.msgTitle,
        isAuthenticated: false,
      }
    case Types.LOGOUT:
      // return {
      //   ...state,
      //   isAuthenticated: false,
      //   relationalType: null,
      // }
      return initalState
    case Types.FORGOT_PASSWORD_REQUEST:
      return {
        ...state,
        errorStatus: 0,
      }
    case Types.FORGOT_PASSWORD_FAILURE:
      return {
        ...state,
        errorStatus: true,
      }
    case Types.FORGOT_PASSWORD_SUCCESS:
      return {
        ...state,
        errorStatus: false,
      }

    case Types.UPDATE_PASSWORD_SUCCESS:
      return {
        ...state,
        otpFlag: 0,
        redirect: 'login-exists',
      }
    case Types.GET_DISTRIBUTOR_SUCCESS:
      return {
        ...state,
        distributorName: action.payload.distributorName,
        distributorImage: action.payload.distributorImage,
        status: action.payload.status,
      }
    case Types.GET_DISTRIBUTOR_FAILURE:
      return {
        ...state,
      }
    case Types.VERIFY_EMAIL_STEP_ONE_SUCCESS:
    case Types.VERIFY_EMAIL_STEP_ONE_FAILURE:
      return {
        ...state,
        msgText: action.payload.msgText,
        existingUser: action.payload.existingUser,
        verificationAttempted: action.payload.verificationAttempted,
        verificationCodeGenerated: action.payload.verificationCodeGenerated,
      }
    case Types.VERIFY_EMAIL_STEP_TWO_SUCCESS:
    case Types.VERIFY_EMAIL_STEP_TWO_FAILURE:
      return {
        ...state,
        msgText: action.payload.msgText,
        emailVerified: action.payload.emailVerified,
        verificationAttempted: action.payload.verificationAttempted,
      }
    case Types.CREATE_ACCOUNT_SUCCESS:
    case Types.CREATE_ACCOUNT_FAILURE:
      return {
        ...state,
        ...action.payload,
        msgText: action.payload.msgText,
      }

    case Types.GET_SCORECARD_SUCCESS:
      return {
        ...state,
        applicationsSubmitted: action.payload.applicationsSubmitted,
        approvalRate: action.payload.approvalRate,
        displayFlag: action.payload.displayFlag,
        excessiveApplicationActivity: action.payload.excessiveApplicationActivity,
        fourMonthLapseRate: action.payload.fourMonthLapseRate,
        freeLookCancel: action.payload.freeLookCancel,
        msgCode: action.payload.msgCode,
        msgText: action.payload.msgText,
        policiesIssued: action.payload.policiesIssued,
        productId: action.payload.productId,
        qualityScore: action.payload.qualityScore,
        statusCode: action.payload.statusCode,
        underwritingInaccuracy: action.payload.underwritingInaccuracy,
      }

    case Types.GET_SCORECARD_FAILURE:
      return {
        ...state,
        // msgCode: action.payload.msgCode,
        // msgText: action.payload.msgText,
        // statusCode: action.payload.statusCode,
      }

    case Types.GET_SCORECARDCHART_SUCCESS:
      return {
        ...state,
        chartTotals: action.payload.chartTotals,
        msgCode: action.payload.msgCode,
        msgText: action.payload.msgText,
        statusCode: action.payload.statusCode,
      }
    case Types.GET_SCORECARDCHART_FAILURE:
      return {
        ...state,
        // msgCode: action.payload.msgCode,
        // msgText: action.payload.msgText,
        // statusCode: action.payload.statusCode,
      }

    case Types.GET_AGGREGATED_DATA_SUCCESS:
      return {
        ...state,
        agentRank: action.payload.agentRank,
        monthlyData: action.payload.monthlyData,
        iaiRate: action.payload.iaiRate,
        msgCode: action.payload.msgCode,
        msgText: action.payload.msgText,
        productAccess: action.payload.productAccess,
        productEligible: action.payload.productEligible,
        productId: action.payload.productId,
        productLibrary: action.payload.productLibrary,
        qualityScore: action.payload.qualityScore,
        quarterlyData: action.payload.quarterlyData,
        statusCode: action.payload.statusCode,
        underwritingInaccuracy: action.payload.underwritingInaccuracy,
        weeklyData: action.payload.weeklyData,
        yearlyData: action.payload.yearlyData,
      }

    case Types.GET_AGGREGATED_DATA_FAILURE:
      return {
        ...state,
        // msgCode: action.payload.msgCode,
        // msgText: action.payload.msgText,
        // statusCode: action.payload.statusCode,
      }

    case Types.GET_OPEN_CASES_SUCCESS:
      return {
        ...state,
        openCases: action.payload.openCases,
      }

    case Types.GET_OPEN_CASES_FAILURE:
      return {
        ...state,
        // msgCode: action.payload.msgCode,
        // msgText: action.payload.msgText,
        // statusCode: action.payload.statusCode,
      }

    case Types.GET_NOTIFICATIONS_SUCCESS:
      return {
        ...state,
        notificationMessage: action.payload.notificationMessage,
      }

    case Types.GET_NOTIFICATIONS_FAILURE:
      return {
        ...state,
        // msgCode: action.payload.msgCode,
        // msgText: action.payload.msgText,
        // statusCode: action.payload.statusCode,
      }
    case Types.GET_AGENT_PRODUCT_SUCCESS:
      return {
        ...state,
        productArray: action.payload,
        userSourceCode: action.payload[0].distributorId,
      }

    case Types.GET_AGENT_PRODUCT_FAILURE:
      return {
        ...state,
        // msgCode: action.payload.msgCode,
        // msgText: action.payload.msgText,
        // statusCode: action.payload.statusCode,
      }
    case Types.GET_USER_PERSONA_SUCCESS:
      return {
        ...state,
        relationalType: action.payload.relationalType,
        userSourceCode: action.payload.userSourceId,
      }

    case Types.GET_USER_PERSONA_FAILURE:
      return {
        ...state,
        // msgCode: action.payload.msgCode,
        // msgText: action.payload.msgText,
        // statusCode: action.payload.statusCode,
      }

    case Types.GET_AGGREGATED_DATA_DIST_SUCCESS:
      return {
        ...state,
        totalNumAgencies: action.payload.totalAgencies,
        totalNumAgents: action.payload.totalAgents,
        monthlyData: action.payload.monthlyData,
        msgCode: action.payload.msgCode,
        msgText: action.payload.msgText,
        productId: action.payload.productId,
        productLibrary: action.payload.productLibrary,
        productAccess: action.payload.productAccess,
        productEligible: action.payload.productEligible,
        qualityScore: action.payload.qualityScore,
        quarterlyData: action.payload.quarterlyData,
        statusCode: action.payload.statusCode,
        weeklyData: action.payload.weeklyData,
        yearlyData: action.payload.yearlyData,
      }

    case Types.GET_AGGREGATED_DATA_DIST_FAILURE:
      return {
        ...state,
        // msgCode: action.payload.msgCode,
        // msgText: action.payload.msgText,
        // statusCode: action.payload.statusCode,
      }

    // case Types.GET_OPEN_CASES_DIST_SUCCESS:
    //   return{

    //   };

    case Types.GET_SCORECARD_DIST_SUCCESS:
      return {
        ...state,
        applicationsSubmitted: action.payload.applicationsSubmitted,
        approvalRate: action.payload.approvalRate,
        displayFlag: action.payload.displayFlag,
        excessiveApplicationActivity: action.payload.excessiveApplicationActivity,
        fourMonthLapseRate: action.payload.fourMonthLapseRate,
        freeLookCancel: action.payload.freeLookCancel,
        msgCode: action.payload.msgCode,
        msgText: action.payload.msgText,
        policiesIssued: action.payload.policiesIssued,
        productId: action.payload.productId,
        qualityScore: action.payload.qualityScore,
        statusCode: action.payload.statusCode,
        underwritingInaccuracy: action.payload.underwritingInaccuracy,
      }

    case Types.GET_SCORECARD_DIST_FAILURE:
      return {
        ...state,
        // msgCode: action.payload.msgCode,
        // msgText: action.payload.msgText,
        // statusCode: action.payload.statusCode,
      }

    case Types.GET_AGENT_LIST_SUCCESS:
      return {
        ...state,
        agentList: action.payload.agentList,
      }

    case Types.GET_AGENT_LIST_FAILURE:
      return {
        ...state,
        // msgCode: action.payload.msgCode,
        // msgText: action.payload.msgText,
        // statusCode: action.payload.statusCode,
      }

    case Types.GET_OPEN_CASES_DIST_SUCCESS:
      return {
        ...state,
        openCases: action.payload.openCases,
      }

    case Types.GET_OPEN_CASES_DIST_FAILURE:
      return {
        ...state,
        // msgCode: action.payload.msgCode,
        // msgText: action.payload.msgText,
        // statusCode: action.payload.statusCode,
      }

    case Types.GET_AFFILIATE_LOGIN_INFO_SUCCESS:
      return {
        ...state,
        redirect: action.payload.redirect,
        // msgCode: action.payload.msgCode,
        // msgText: action.payload.msgText,
        // statusCode: action.payload.statusCode,
      }

    case Types.GET_AFFILIATE_LOGIN_INFO_FAILURE:
      return {
        ...state,
        // msgCode: action.payload.msgCode,
        // msgText: action.payload.msgText,
        // statusCode: action.payload.statusCode,
      }

    case Types.GET_OTP_SUCCESS:
      return {
        ...state,
        otpStatus: action.payload.otpStatus,
      }

    case Types.VALIDATE_OTP_SUCCESS:
      return {
        ...state,
        otpValidateStatus: action.payload.otpValidateStatus,
        isAuthenticated: true,
        loginError: false,
        // email: 'aarona@yopmail.com',
        // firstName: 'Aaron',
        // affiliateCode: 'SFG0036305',
      }
    case Types.VALIDATE_OTP_FAILURE:
      return {
        ...state,
        otpValidateStatus: action.payload.otpValidateStatus,
        isAuthenticated: false,
        loginError: true,
        // email: 'aarona@yopmail.com',
        // firstName: 'Aaron',
        // affiliateCode: 'SFG0036305',
      }

    case Types.GET_SCORECARDCHART_PERSONA_SUCCESS:
      return {
        ...state,
        chartTotals: action.payload.chartTotals,
        // msgCode: action.payload.msgCode,
        // msgText: action.payload.msgText,
        // statusCode: action.payload.statusCode,
      }
    case Types.GET_SCORECARDCHART_PERSONA_FAILURE:
      return {
        ...state,
        // msgCode: action.payload.msgCode,
        // msgText: action.payload.msgText,
        // statusCode: action.payload.statusCode,
      }

    case Types.GET_AGENCYPRODUCTLIST_DISTRIBUTOR_PERSONA_SUCCESS:
      return {
        ...state,
        distributorList: action.payload.distributorList,
        agencyList: action.payload.agencyList,
        productList: action.payload.productList,
      }
    case Types.GET_AGENCYPRODUCTLIST_AGENCY_PERSONA_SUCCESS:
      return {
        ...state,
        agencyList: action.payload.agencyList,
        productList: action.payload.productList,
      }
    case Types.GET_AGENCYPRODUCTLIST_PRODUCT_PERSONA_SUCCESS:
      return {
        ...state,
        productList: action.payload.productList,
      }
    case Types.GET_AGENCYPRODUCTLIST_PERSONA_FAILURE:
      return {
        ...state,
        // msgCode: action.payload.msgCode,
        // msgText: action.payload.msgText,
        // statusCode: action.payload.statusCode,
      }
    case Types.SSO_LOGIN_SUCCESS:
      return {
        ...state,
        isAuthenticated: true,
        firstName: action.payload.firstName,
        lastName: action.payload.lastName,
        relationalType: 117,
      }
    case Types.SSO_LOGIN_FAILURE:
      return {
        ...state,
        // msgCode: action.payload.msgCode,
        // msgText: action.payload.msgText,
        // statusCode: action.payload.statusCode,
      }

    case Types.HUBSPOT_TICKET_SUCCESS:
      return {
        ...state,
      }
    case Types.HUBSPOT_TICKET_FAILURE:
      return {
        ...state,
        // msgCode: action.payload.msgCode,
        // msgText: action.payload.msgText,
        // statusCode: action.payload.statusCode,
      }

    default:
      return state
  }
}
